import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './ProductForm.css';

const ProductConfiguration = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('general');
    const [salesChecked, setSalesChecked] = useState(true);

    useEffect(() => {
        if (!salesChecked && activeTab === 'prices') {
            setActiveTab('general');
        }
    }, [salesChecked, activeTab]);

    return (
        <div className="pm-page-card">
            <div className="pm-header">
                <h2 className="pm-header-title">{t('inventory.config_tab')}</h2>
            </div>

            <div className="pm-section-note">
                {t('inventory.form_not_connected_note')}
            </div>

            <div className="pm-config-form">
                <div className="pm-config-header">
                    <div className="pm-form-group" style={{ flex: 1, minWidth: 200 }}>
                        <label>{t('inventory.product_name_placeholder')}</label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <input
                                type="checkbox"
                                id="product_favorite"
                                defaultChecked={false}
                            />
                            <input type="text" placeholder={t('inventory.product_name_placeholder')} />
                        </div>
                    </div>
                    <div className="pm-config-image-upload">
                        <span aria-hidden="true">📷</span>
                    </div>
                </div>

                <div className="pm-toggle-row">
                    <label>
                        <input
                            type="checkbox"
                            id="sales"
                            checked={salesChecked}
                            onChange={(e) => setSalesChecked(e.target.checked)}
                        />
                        <span>{t('inventory.sales_checkbox_label')}</span>
                    </label>
                </div>

                <div className="pm-config-tabs">
                    <button
                        className={`pm-config-tab ${activeTab === 'general' ? 'active' : ''}`}
                        onClick={() => setActiveTab('general')}
                    >
                        {t('inventory.general_information_tab')}
                    </button>
                    {salesChecked && (
                        <button
                            className={`pm-config-tab ${activeTab === 'prices' ? 'active' : ''}`}
                            onClick={() => setActiveTab('prices')}
                        >
                            {t('inventory.prices_tab')}
                        </button>
                    )}
                    <button
                        className={`pm-config-tab ${activeTab === 'inventory' ? 'active' : ''}`}
                        onClick={() => setActiveTab('inventory')}
                    >
                        {t('inventory.inventory_tab')}
                    </button>
                </div>

                <div className="pm-config-section">
                    {activeTab === 'general' && (
                        <div className="pm-form-grid">
                            <div className="pm-subsection-title">{t('inventory.product_type_label')}</div>
                            <div className="pm-form-group full-width">
                                <div className="pm-toggle-row">
                                    <label>
                                        <input type="radio" id="goods" name="product_type" value="goods" defaultChecked />
                                        <span>{t('inventory.goods_option')}</span>
                                    </label>
                                    <label>
                                        <input type="radio" id="service" name="product_type" value="service" />
                                        <span>{t('inventory.service_option')}</span>
                                    </label>
                                    <label>
                                        <input type="radio" id="combo" name="product_type" value="combo" />
                                        <span>{t('inventory.combo_option')}</span>
                                    </label>
                                </div>
                            </div>
                            <div className="pm-form-group">
                                <label>{t('inventory.sales_price_label')}</label>
                                <input type="text" defaultValue="1.00 $" />
                            </div>
                            <div className="pm-form-group">
                                <label>{t('inventory.track_inventory_label')}</label>
                                <input type="checkbox" defaultChecked />
                            </div>
                            <div className="pm-form-group">
                                <label>{t('inventory.cost_label')}</label>
                                <input type="text" defaultValue="0.00 $" />
                            </div>
                            <div className="pm-form-group">
                                <label>{t('inventory.quantity_on_hand_label')}</label>
                                <input type="text" defaultValue="0.00" readOnly />
                            </div>
                            <div className="pm-form-group">
                                <label>{t('inventory.category_label')}</label>
                                <input type="text" />
                            </div>
                            <div className="pm-form-group">
                                <label>{t('inventory.reference_label')}</label>
                                <input type="text" />
                            </div>
                            <div className="pm-form-group">
                                <label>{t('inventory.barcode_label')}</label>
                                <input type="text" />
                            </div>
                            <div className="pm-form-group full-width">
                                <label>{t('inventory.internal_notes_label')}</label>
                                <textarea placeholder={t('inventory.internal_notes_placeholder')}></textarea>
                            </div>
                        </div>
                    )}
                    {activeTab === 'prices' && salesChecked && (
                        <div className="pm-config-section">
                            <div className="pm-data-table">
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', padding: '0.75rem 1rem', background: 'var(--pico-card-sectioning-background-color)', borderBottom: '1px solid var(--pico-muted-border-color)', fontWeight: 600, fontSize: '0.8rem', color: 'var(--pico-muted-color)' }}>
                                    <span>{t('inventory.pricelist_header')}</span>
                                    <span>{t('inventory.price_header')}</span>
                                    <span>{t('inventory.min_quantity_header')}</span>
                                </div>
                                <div style={{ padding: '0.75rem 1rem' }}>
                                    <a href="#" className="add-price-link" onClick={(e) => e.preventDefault()}>
                                        {t('inventory.add_price_link')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === 'inventory' && (
                        <div className="pm-form-grid">
                            <div className="pm-subsection-title">{t('inventory.logistics_heading')}</div>
                            <div className="pm-form-group">
                                <label>{t('inventory.responsible_label')}</label>
                                <input type="text" placeholder={t('inventory.responsible_placeholder')} />
                            </div>
                            <div className="pm-form-group">
                                <label>{t('inventory.weight_label')}</label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <input type="text" defaultValue="0.00" style={{ flex: 1 }} />
                                    <span>kg</span>
                                </div>
                            </div>
                            <div className="pm-form-group">
                                <label>{t('inventory.volume_label')}</label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <input type="text" defaultValue="0.00" style={{ flex: 1 }} />
                                    <span>m³</span>
                                </div>
                            </div>
                            <div className="pm-form-group">
                                <label>{t('inventory.customer_lead_time_label')}</label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <input type="text" defaultValue="0" style={{ flex: 1 }} />
                                    <span>days</span>
                                </div>
                            </div>
                            <div className="pm-form-group full-width">
                                <label>{t('inventory.description_receipts_label')}</label>
                                <textarea placeholder={t('inventory.description_receipts_placeholder')}></textarea>
                            </div>
                            <div className="pm-form-group full-width">
                                <label>{t('inventory.description_delivery_label')}</label>
                                <textarea placeholder={t('inventory.description_delivery_placeholder')}></textarea>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductConfiguration;
